/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutotraderDealEventDataAutotraderEventRequest } from '../models/AutotraderDealEventDataAutotraderEventRequest';
import type { AutotraderFeature } from '../models/AutotraderFeature';
import type { AutotraderStockEventDataAutotraderEventRequest } from '../models/AutotraderStockEventDataAutotraderEventRequest';
import type { AutotraderVehicleDto } from '../models/AutoTraderVehicleDto';
import type { BranchType } from '../models/BranchType';
import type { CompetitorsResponse } from '../models/CompetitorsResponse';
import type { MessageModel } from '../models/MessageModel';
import type { MotTest } from '../models/MotTest';
import type { SaveAutoTraderStockDto } from '../models/SaveAutoTraderStockDto';
import type { Vehicle } from '../models/Vehicle';
import type { VehicleResponse } from '../models/VehicleResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AutotraderService {

  /**
   * @param regNo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns CompetitorsResponse Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderCompetitors(
regNo?: string,
branch?: BranchType,
): CancelablePromise<CompetitorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/competitors',
      query: {
        'regNo': regNo,
        'branch': branch,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns VehicleResponse Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderUsedLookup(
stockId: number,
): CancelablePromise<VehicleResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/used/lookup/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @param modelId 
   * @param generationId 
   * @param trim 
   * @param derivativeId 
   * @returns VehicleResponse Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderNewLookup(
stockId: number,
modelId?: string,
generationId?: string,
trim?: string,
derivativeId?: string,
): CancelablePromise<VehicleResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/new/lookup/{stockId}',
      path: {
        'stockId': stockId,
      },
      query: {
        'modelId': modelId,
        'generationId': generationId,
        'trim': trim,
        'derivativeId': derivativeId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns Vehicle Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderFullInfo(
stockId: number,
): CancelablePromise<Vehicle> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/full-info/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns MotTest Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderMotTests(
stockId: number,
): CancelablePromise<Array<MotTest>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/mot-tests/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns AutotraderFeature Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderFeatures(
stockId: number,
): CancelablePromise<Array<AutotraderFeature>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/features/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns MessageModel Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderMessages(
stockId: number,
): CancelablePromise<Array<MessageModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/messages/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns AutotraderVehicleDto Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderUsedInfo(
stockId: number,
): CancelablePromise<AutotraderVehicleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/used/{stockId}/info',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns AutotraderVehicleDto Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderNewInfo(
stockId: number,
): CancelablePromise<AutotraderVehicleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/new/{stockId}/info',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param stockId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclesAutotraderStock(
stockId: number,
requestBody?: SaveAutoTraderStockDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicles/autotrader/stock/{stockId}',
      path: {
        'stockId': stockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns void 
   * @throws ApiError
   */
  public static putVehiclesAutotraderStockPrice(
stockId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicles/autotrader/stock/{stockId}/price',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclesAutotraderSync(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicles/autotrader/sync',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVehiclesAutotraderWebhooksUpdateEvent(
requestBody?: AutotraderStockEventDataAutotraderEventRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicles/autotrader/webhooks/update-event',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putDealsAutotraderWebhooksUpdateEvent(
requestBody?: AutotraderDealEventDataAutotraderEventRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/deals/autotrader/webhooks/update-event',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param dealUid 
   * @returns any Success
   * @throws ApiError
   */
  public static getDealsAutotraderApiQueryLog(
dealUid: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/deals/autotrader/api-query-log/{dealUid}',
      path: {
        'dealUid': dealUid,
      },
    });
  }

}
